"use client";

import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "./cn";

/** Single-line text field. Token-based border, ring and placeholder. */
export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, type = "text", ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          "w-full h-9 px-3 rounded-control text-sm",
          "bg-surface text-foreground placeholder:text-subtle-foreground",
          "border border-border",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          className,
        )}
        {...props}
      />
    );
  },
);
